import React from 'react'
import BaseIcon from 'react-icon-base'

import { IIconProps } from './interface'

const Back = ({ pathProps = {}, ...props }: IIconProps) => (
  <BaseIcon width="10" height="16" viewBox="0 0 10 16" {...props}>
    <path
      fill="#617182"
      fillRule="evenodd"
      d="M8.003.292L.662 6.556c-.883.78-.883 2.047 0 2.827l7.409 6.325c.437.385 1.143.39 1.586.01a.921.921 0 0 0 .012-1.425L3.058 8.676a.92.92 0 0 1 0-1.414L9.6 1.705a.92.92 0 0 0 0-1.413 1.237 1.237 0 0 0-1.597 0z"
      {...pathProps}
    />
  </BaseIcon>
)

export default Back
